// the core-js modules that the browserslist targets lack, see babel.config.js
import 'core-js/stable'

// imports
import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import App from './App'
import configureStore from './configureStore'
import * as serviceWorker from './serviceWorker'
import * as Sentry from '@sentry/browser'

const HOST = process.env.HOST
const SENTRY_DSN = process.env.SENTRY_DSN

// initialize Sentry error logging
if (SENTRY_DSN)
  Sentry.init({ tunnel: '/sentry-tunnel/', dsn: SENTRY_DSN, environment: HOST })

const root = createRoot(document.getElementById('app') as HTMLElement)

const stopDoubleClickSelect = (ev: MouseEvent) => {
  // event.detail is the number of mouse clicks in a sequence
  // single click is 1, double click is 2 etc.
  // this disables the default text selection behaviour of double and triple
  // clicks
  if (ev.detail && ev.detail > 1) {
    // keep default if event target is a form element
    if (!(ev.target && 'form' in ev.target)) ev.preventDefault()
  }
}

document.removeEventListener('mousedown', stopDoubleClickSelect)
document.addEventListener('mousedown', stopDoubleClickSelect)

// a hot reload renders the new App into the same root
const render = (
  App: React.ComponentType,
  store: ReturnType<typeof configureStore>,
) =>
  root.render(
    <Provider store={store}>
      <App />
    </Provider>,
  )

const store = configureStore()
render(App, store)
if (module.hot)
  module.hot.accept('./App', () => {
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    render(require('./App').default, store)
  })

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()
